import { Model, Factory } from 'miragejs'

export const model = Model
export const factory = Factory.extend({})
